import { CreateTeamDrawer, Row, Spacer } from '../../components';
import { Button, Typography, capitalize } from '@mui/material';
import { useState } from 'react';
import { AdminTierTypeEnum } from '../../services/drillDown';
import { AvailablePricebooks, PricebookBundle } from '../../models/PricebookData';

interface AdminTierHeaderProps {
  onCreate: (values: any) => void;
  hideCreate?: boolean;
  tierIcon?: React.ReactNode;
  tier: string;
  groupAvailablePricebooks?: AvailablePricebooks;
  allPricebookBundles?: PricebookBundle[];
}

const AdminTierHeader: React.FC<AdminTierHeaderProps> = ({
  onCreate,
  hideCreate,
  tierIcon,
  tier,
  groupAvailablePricebooks,
  allPricebookBundles,
}) => {
  const [createDrawer, setCreateDrawer] = useState(false);

  return (
    <Row style={{ justifyContent: 'space-between', alignItems: 'center' }}>
      <Row style={{ alignItems: 'center' }}>
        {tierIcon && (
          <>
            {tierIcon}
            <Spacer width='xs' />
          </>
        )}
        <Typography variant='p30' color='secondary.main'>
          Your {tier?.toLowerCase()}s
        </Typography>
      </Row>
      {!hideCreate && (
        <Button
          onClick={() =>
            capitalize(tier) === AdminTierTypeEnum.Organization
              ? onCreate(null)
              : setCreateDrawer(true)
          }>
          Create new {tier?.toLowerCase()}
        </Button>
      )}
      <CreateTeamDrawer
        drawerOpen={createDrawer}
        setDrawerOpen={setCreateDrawer}
        onSubmit={onCreate}
        groupAvailablePricebooks={groupAvailablePricebooks}
        allPricebookBundles={allPricebookBundles}
      />
    </Row>
  );
};

export default AdminTierHeader;
